import { songInfoType } from './types/Song.td';

const chillHop = (): songInfoType[] => {
	return [
		{
			name: 'Beaver Creek',
			cover:
				'https://images.unsplash.com/photo-1565638427888-268b7714225e?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=50',
			artist: 'Aso, Middle School, Aviino',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=10075',
			color: ['#205950', '#2ab3bf'],
			id: 'd6aeb71b-7078-4292-a430-97f7bb3f8b9b',
			active: true,
		},
		{
			name: 'Daylight',
			cover:
				'https://images.unsplash.com/photo-1581337204873-ef36aa186caa?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1338&q=50',
			artist: 'Aiguille',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=9272',
			color: ['#EF8EA9', '#ab417f'],
			id: 'ec7040b1-6f20-40b7-87f4-44e153730450',
			active: false,
		},
		{
			name: 'Keep Going',
			cover:
				'https://images.unsplash.com/photo-1546497621-27d1282f7af2?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=50',
			artist: 'Swørn',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=9222',
			color: ['#CD607D', '#c94043'],
			id: 'fb611c94-ca58-4dca-8b27-d58aa1cc7c0e',
			active: false,
		},
		{
			name: 'Nightfall',
			cover:
				'https://images.unsplash.com/photo-1520013817300-1f4c1cb245ef?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1387&q=50',
			artist: 'Aiguille',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=9148',
			color: ['#EF8EA9', '#ab417f'],
			id: '489d9477-4be2-4c48-b05d-dbcbc419560a',
			active: false,
		},
		{
			name: 'Reflection',
			cover:
				'https://images.unsplash.com/photo-1481349518771-20055b2a7b24?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1409&q=50',
			artist: 'Swørn',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=9228',
			color: ['#CD607D', '#c94043'],
			id: '5809f031-4a00-4755-afa2-d36f2fa0d340',
			active: false,
		},
		{
			name: 'Under the City Stars',
			cover:
				'https://images.unsplash.com/photo-1485939420171-378de92ecd4c?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1350&q=50',
			artist: 'Aso, Middle School, Aviino',
			audio: 'https://mp3.chillhop.com/serve.php/?mp3=10074',
			color: ['#205950', '#2ab3bf'],
			id: 'e5b9d5dd-9072-44b1-9702-c85ff2924416',
			active: false,
		},
		//ADD MORE HERE
	];
};

export default chillHop;
